import Num2persian from 'num2persian';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {
  Animated,
  AppState,
  BackHandler,
  FlatList,
  Keyboard,
  Linking,
  Platform,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {TextInput} from 'react-native-paper';
import {useMutation} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import {hideAlert, showAlert} from '../../../../actions/AlertActions';
import {getApp} from '../../../../actions/app';
import {showSheet} from '../../../../actions/SheetActions';
import {getUser} from '../../../../actions/user';
import FabBackButton from '../../../../components/fab-back-button/FabBackButton.componet';
import ValidLabelField from '../../../../components/fields/valid-label-field/ValidLabelField.component';
import PrimaryButton from '../../../../components/primary-button/PrimaryButton.component';
import {isWeb} from '../../../../constants';
import {useCharge} from '../../../../hooks/useValidations';
import {useApi} from '../../../../providers/ApiProvider';
import {selectrootsheettype} from '../../../../selectors/SheetSelector';
import {selecetusertype} from '../../../../selectors/User';
import {
  AnalyticsEvent,
  AnalyticsUserProperties,
} from '../../../../services/analytics/FirebaseAnalytics';
import {colorPalette} from '../../../../theme';
import {
  inputNumberFormatter,
  staticNumberFormatter,
} from '../../../../utils/NumberFormatter';
import styles from './WalletChargeSheet.style';
import {Is} from '../../../../utils/ValidationTools';
import fixNumbers from '../../../../utils/FixNumbers';
import {useHistory} from '../../../../imports/Router';
import Sentry from 'src/imports/sentry';

const data = [100000, 200000, 500000];

const Item = props => {
  const {item, index, selected, onPress} = props;
  const {t} = useTranslation();
  return (
    <TouchableOpacity
      style={[
        styles.itemContainer,
        {
          marginRight: index === 0 ? 16 : 8,
          marginLeft: index === data?.length - 1 ? 16 : 0,
          backgroundColor: selected === item ? colorPalette.primary : undefined,
        },
      ]}
      onPress={onPress}>
      <Text
        style={[
          styles.itemUnit,
          {
            color:
              selected === item ? colorPalette.grey1_5 : colorPalette.primary,
          },
        ]}>
        {' '}
        {t('toman')}
      </Text>
      <Text
        style={[
          styles.itemNumber,
          {
            color:
              selected === item ? colorPalette.whiteGrey0 : colorPalette.grey9,
          },
        ]}>
        {staticNumberFormatter(item)}
      </Text>
    </TouchableOpacity>
  );
};

export default function WalletChaegeSheet(props) {
  const {} = props;
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {api} = useApi();
  const translateY = useRef(new Animated.Value(421)).current;
  const {sheetId} = useSelector(state => selectrootsheettype(state));
  const {wallet_credit} = useSelector(state => selecetusertype(state));
  const [selected, setSelected] = useState();
  const [validationEnabled, setValidationEnabled] = useState(false);
  const {hasPayment} = useSelector(state => state?.app);
  const history = useHistory();
  var purchase_value = '';
  const lin = useRef('');

  useEffect(() => {
    switch (sheetId) {
      case 'walletCharge':
        Animated.timing(translateY, {
          toValue: 0,
          duration: 200,
          useNativeDriver: true,
        }).start();
        break;
      default:
        closeHandler();
        break;
    }
  }, [sheetId]);

  const closeHandler = () => {
    Animated.timing(translateY, {
      toValue: 421,
      duration: 400,
      useNativeDriver: true,
    }).start();
    setTimeout(() => {
      dispatch(showSheet({sheetId: ''}));
    }, 400);
  };

  const {
    value: charge,
    setValue: setCharge,
    result: chargeValidation,
    checkError: chargeCheckError,
  } = useCharge(!validationEnabled);

  function onSubmit() {
    Keyboard.dismiss();
    const numericCharge = Number(charge);

    if (!numericCharge || numericCharge <= 0) {
      setValidationEnabled(true);
      return;
    }

    if (chargeCheckError()) {
      setValidationEnabled(true);
    } else {
      paymentHandler();
    }
  }

  const renderItem = ({item, index}) => {
    return (
      <Item
        item={item}
        index={index}
        selected={selected}
        onPress={() => {
          setCharge(item);
          setSelected(item);
        }}
      />
    );
  };

  const openInNewTab = () => {
    lin.current = window.open('about:blank', '_blank');
    lin.current.opener = null;
  };

  const paymentRequestPaymentMutation = useMutation({
    mutationFn: async body => {
      return api.paymentRequestPayment(body);
    },
    onSuccess: response => {
      let link = response?.Data?.url;
      isWeb ? (lin.current.location.href = link) : Linking.openURL(link);
      dispatch(
        getApp({
          hasPayment: true,
        }),
      );
      if (isWeb) {
        dispatch(
          showAlert({
            id: 'Loading',
          }),
        );
      }
    },
    onError: error => {
      const error_type = error?.response?.data?.Result;
      const status = error?.response?.status;
      const errorMesage =
        error?.message === 'Network Error' ? 'Network Error' : error_type;
      Sentry.setTag('api_error', 'payment_request');
      Sentry.captureMessage(
        `Error in payment request ${errorMesage} - ${status}`,
      );
      dispatch(
        getApp({
          hasPayment: false,
        }),
      );
      if (error?.response?.status === 404) {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title: t('connecting_payment_gateway_fail'),
              message: t('please_try_again_after_few_moment'),
            },
          }),
        );
      }
    },
  });

  function paymentHandler() {
    if (isWeb) {
      openInNewTab();
    }
    paymentRequestPaymentMutation.mutate({
      Amount: charge,
      Type: Platform.OS !== 'web' ? 1 : 2,
    });
    purchase_value = charge;
  }

  useEffect(() => {
    if (isWeb) {
      const subscrption = AppState.addEventListener(
        'change',
        handleAppStateChange,
      );
      return () => {
        subscrption.remove();
      };
    } else {
      const backHandler = BackHandler.addEventListener(
        'hardwareBackPress',
        handleBackButtonClick,
      );
      const subscrption = Linking.addEventListener('url', handleOpenURL);

      return () => {
        backHandler.remove();
        subscrption.remove();
      };
    }
  }, [hasPayment]);

  const lastPaymentMutation = useMutation({
    mutationFn: async () => {
      return api.lastPaymentStatus();
    },
    onSuccess: response => {
      const success = response?.Data?.PaymentSuccess ?? false;
      const message = response?.Data?.CheckoutDescription ?? '';
      const depositCredit = response?.Data?.DepositCredit ?? 0;
      const walletCredit = response?.Data?.WalletCredit ?? 0;
      dispatch(hideAlert());
      dispatch(
        getUser({
          deposit_credit: depositCredit,
          wallet_credit: walletCredit,
        }),
      );
      if (message !== '' && !success) {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: success ? 'greenTick' : 'redExclamation',
              title: message,
            },
          }),
        );
      }
      if (success) {
        closeHandler();
        history.push({
          pathname: '/payment-success',
          state: {
            title: 'your_balance_increased',
            description:
              message !== '' ? message : t('wallet_balance_increased'),
            buttonTitle: 'back_to_map',
            route: '/main/map',
          },
        });
        AnalyticsEvent({
          type: 'purchase',
          params: {
            purchase_amount: purchase_value,
            payment_method: 'cash',
            purchase_purpose: 'credit_tapup',
          },
        });
        AnalyticsEvent({
          type: 'paid_deposit',
        });
        AnalyticsUserProperties({
          user_deposit: 'paid',
        });
      } else {
        closeHandler();
        history.push({
          pathname: '/payment-error',
          state: {
            buttonTitle: 'back_to_map',
            route: '/main/map',
          },
        });
      }
    },
    onError: err => {
      dispatch(hideAlert());
      console.log('err', err.response);
    },
  });

  //---------------------------------------------------handle payment deeplink
  const handleAppStateChange = useCallback(
    nextAppState => {
      if (nextAppState === 'active' && hasPayment) {
        lastPaymentMutation.mutate();
        dispatch(
          getApp({
            hasPayment: false,
          }),
        );
      }
    },
    [hasPayment],
  );

  const handleOpenURL = async ev => {
    const route = ev.url;
    if (route.includes('Status')) {
      dispatch(
        showAlert({
          id: 'Loading',
        }),
      );
      lastPaymentMutation.mutate();
    }
  };
  //---------------------------------------------------

  function handleBackButtonClick() {
    closeHandler();
    return true;
  }

  return (
    <>
      <TouchableOpacity
        activeOpacity={1}
        onPress={closeHandler}
        style={styles.container}
      />
      <Animated.View
        style={[{transform: [{translateY: translateY}]}, styles.content]}>
        <View style={styles.indicator} />
        <View style={styles.header}>
          <FabBackButton
            container_style={styles.backButton}
            onPress={closeHandler}
            icon={'closeIcon'}
          />
          <Text style={styles.screenTitle}>{t('increase_wallet_balance')}</Text>
        </View>
        <ValidLabelField
          inputStyle={styles.inputStyle}
          label={''}
          keyboardType="number-pad"
          returnKeyType="done"
          value={inputNumberFormatter(charge)}
          onChangeText={value => {
            setCharge(Number(fixNumbers(value.replaceAll(',', ''))));
            setSelected(false);
          }}
          containerStyle={styles.input}
          left={
            <TextInput.Icon
              icon={() => {
                return <Text style={styles.inputLeft}>{t('toman')}</Text>;
              }}
            />
          }
          isError={validationEnabled && chargeCheckError()}
          errorText={chargeValidation.error}
        />
        {!!charge && (
          <Text style={styles.persianNum}>
            {Num2persian(charge)} {t('toman')}
          </Text>
        )}
        <Text style={[styles.otherWay, [{marginTop: charge ? 20 : 54}]]}>
          {t('or_choose_suggestions')}
        </Text>
        <FlatList
          style={styles.list}
          data={data}
          renderItem={renderItem}
          keyExtractor={item => item}
          horizontal
          inverted
        />
        <View style={styles.currentContainer}>
          <Text style={styles.currentNumber}>
            {staticNumberFormatter(wallet_credit)}
            <Text style={styles.currentUnit}> {t('toman')}</Text>
          </Text>
          <Text style={styles.currentTitle}>{t('current_balance')}</Text>
        </View>
        <PrimaryButton
          title={t('add_balance')}
          containerStyle={[styles.button, !charge && styles.disabledButton]}
          onPress={onSubmit}
        />
      </Animated.View>
    </>
  );
}
